import { render, staticRenderFns } from "./ParallelSource.vue?vue&type=template&id=ed8d4af2&scoped=true"
import script from "./ParallelSource.vue?vue&type=script&lang=ts"
export * from "./ParallelSource.vue?vue&type=script&lang=ts"
import style0 from "./ParallelSource.vue?vue&type=style&index=0&id=ed8d4af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8d4af2",
  null
  
)

export default component.exports